<div *ngIf="loading" class="loader"></div>

<!-- Request Summary Desktop -->
<div *ngIf="!isMobile()" class="submenu flex-row ai-center">
  <div class="submenu__summary flex jc-sb ai-c">
    <h6 class="submenu__title">Selected Request: <a routerLink="/my-dashboard/my-requests">#{{
        requestId }}
        <span>(change)</span></a></h6>
    <div class="flex ai-c">
      <p><img src="../../../assets/img/icons/check-in.svg" alt="Check In Icon"> Check in: {{ requestForSearch.fromdate
        }}
      </p>
      <p><img src="../../../assets/img/icons/check-out.svg" alt="Check Out Icon"> Check out: {{ requestForSearch.todate
        }}
      </p>
      <p><img src="../../../assets/img/icons/room.svg" alt="Room Icon"> Room(s): {{ requestForSearch.rooms }}</p>
      <p><img src="../../../assets/img/icons/adult.svg" alt="Adult Icon"> Adults: {{ requestForSearch.adults }}</p>
      <p><img src="../../../assets/img/icons/child.svg" alt="Child Icon"> Children: {{ requestForSearch.children }}</p>
      <p><img src="../../../assets/img/icons/location.svg" alt="Destination Icon"> Destination: {{
        requestForSearch.region
        }}</p>
    </div>
  </div>
</div>

<!-- PROPERTY PAGE START -->
<div id="singleHotel" class="property__container" *ngIf="!loading">

  <!-- Carousel UI Components -->
  <span *ngIf="isMobile()" (click)="goBack()" class="arrow__back"><img src="../../../../assets/img/icons/icon_back.svg"
      alt="Back Icon" /></span>
  <div *ngIf="isMobile()" class="request__details--mobile">
    <button (click)="showSummary = !showSummary" class="dark-bg">
      Request Summary
      <svg [ngStyle]="showSummary ? {'transform' : 'rotate(-90deg)'} : {}" width="8" height="12" viewBox="0 0 8 12"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.12598 1.74803L6.08011 6.18634L1.12598 10.748" stroke="#fff" stroke-width="2" />
      </svg>
    </button>
    <div *ngIf="offerInfo && showSummary" class="dark-bg request__details-container">
      <p class="checkinoutm">
        <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.5 6.49191H4.5V7.49191H3.5V6.49191ZM10.5 3.99191V10.9919C10.5 11.5419 10.05 11.9919 9.5 11.9919H2.5C2.23478 11.9919 1.98043 11.8866 1.79289 11.699C1.60536 11.5115 1.5 11.2571 1.5 10.9919L1.505 3.99191C1.505 3.44191 1.945 2.99191 2.5 2.99191H3V1.99191H4V2.99191H8V1.99191H9V2.99191H9.5C10.05 2.99191 10.5 3.44191 10.5 3.99191ZM2.5 4.99191H9.5V3.99191H2.5V4.99191ZM9.5 10.9919V5.99191H2.5V10.9919H9.5ZM7.5 7.49191H8.5V6.49191H7.5V7.49191ZM5.5 7.49191H6.5V6.49191H5.5V7.49191Z"
            fill="white" />
        </svg>
        {{ carouselDate }}
      </p>
      <p class="guestsm">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
          <g clip-path="url(#a)">
            <path fill="#fff"
              d="M5 2.825c-.53 0-1.04.193-1.414.537A1.76 1.76 0 0 0 3 4.66c0 .486.21.952.586 1.296.375.344.884.537 1.414.537.53 0 1.04-.193 1.414-.537A1.76 1.76 0 0 0 7 4.659c0-.487-.21-.953-.586-1.297A2.096 2.096 0 0 0 5 2.825ZM2 4.66c0-.73.316-1.43.879-1.945A3.144 3.144 0 0 1 5 1.909c.796 0 1.559.29 2.121.805A2.64 2.64 0 0 1 8 4.659a2.64 2.64 0 0 1-.879 1.944A3.144 3.144 0 0 1 5 7.41c-.796 0-1.559-.29-2.121-.806A2.64 2.64 0 0 1 2 4.66Zm6.414-1.945a.54.54 0 0 1 .707 0c.28.255.5.558.65.892a2.552 2.552 0 0 1 0 2.105c-.15.334-.37.637-.65.892a.54.54 0 0 1-.707 0 .458.458 0 0 1-.108-.149.426.426 0 0 1 .108-.5A1.76 1.76 0 0 0 9 4.66c0-.487-.211-.953-.586-1.297a.458.458 0 0 1-.109-.148.425.425 0 0 1 .109-.5Zm.351 5.958a.464.464 0 0 1 .228-.281.54.54 0 0 1 .378-.052c.664.152 1.085.54 1.326.984.234.429.303.908.303 1.294a.44.44 0 0 1-.146.324.524.524 0 0 1-.354.134.524.524 0 0 1-.354-.134.44.44 0 0 1-.146-.324c0-.301-.056-.625-.197-.884a.972.972 0 0 0-.675-.505.498.498 0 0 1-.307-.209.426.426 0 0 1-.056-.346Zm-5.515.57c-.63 0-1.25.556-1.25 1.375a.44.44 0 0 1-.146.324.524.524 0 0 1-.354.134.524.524 0 0 1-.354-.134.44.44 0 0 1-.146-.324c0-1.206.946-2.292 2.25-2.292h3.5C8.053 8.325 9 9.411 9 10.617a.44.44 0 0 1-.146.324.524.524 0 0 1-.354.134.524.524 0 0 1-.354-.134.44.44 0 0 1-.146-.324c0-.82-.62-1.375-1.25-1.375h-3.5Z" />
          </g>
        </svg>
        {{ guests }} Guests
      </p>
      <p class="checkinoutm">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none">
          <g clip-path="url(#a)">
            <path fill="#fff"
              d="M6 2.992c1.1 0 2 .9 2 2 0 1.05-1.05 2.75-2 3.95-.95-1.25-2-2.9-2-3.95 0-1.1.9-2 2-2Zm0-1c-1.65 0-3 1.35-3 3 0 2.25 3 5.5 3 5.5s3-3.3 3-5.5c0-1.65-1.35-3-3-3Zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 6.5c0 1.1-1.8 2-4 2s-4-.9-4-2c0-.65.6-1.2 1.55-1.6l.3.45c-.5.25-.85.55-.85.9 0 .7 1.35 1.25 3 1.25s3-.55 3-1.25c0-.35-.35-.65-.9-.9l.3-.45c1 .4 1.6.95 1.6 1.6Z" />
          </g>
        </svg>
        {{ offerInfo.offer.bookingRequest.destination.toString().split(',').join(', ') }}
      </p>
      <p class="checkinoutm">{{ offerInfo.offer.bookingRequest.personalRequest }}</p>
      <div *ngIf="finalWishes && finalWishes.size > 0">
        <p *ngFor="let wish of finalWishes | keyvalue">
          <span>{{ wish.key }}</span>
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="isMobile() && offerInfo" class="gallery__count">
    <div class="dark-bg">
      <span>{{ swiperRealIndex }} / {{ offerInfo.propertyPics.length }}</span>
    </div>
  </div>

  <!-- Property Name & Location for Desktop -->
  <div *ngIf="!isMobile() && this.offerInfo" class="property__info flex jc-sb ai-c w-100 gap-2">
    <div class="flex gap-2 ai-c">
      <h3 class="property__name">{{ offerInfo.hotel.name }}</h3>
      <div *ngIf="!isOffer" class="property__request-offer flex ai-c">
        <a (click)="requestUniqueOffer()">
          <img src="../../../../assets/img/icons/icon_fire.svg" alt="Fiery Discount Icon for Exclusive Offers" />
          Request Exclusive Offer
        </a>
        <div #ruoOverview (click)="isRuoOpen = !isRuoOpen" class="tooltip-trigger-icon">
          <svg class="tooltip-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218 218">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <circle cx="109" cy="109" r="109" />
                <path class="tooltip-icon-i"
                  d="M83.62,90.37h41.32V167.6h9.44v3H84.3v-3h9.27V93.4H83.62Zm25.47-11.64q-9,0-12.74-4.55a17,17,0,0,1-3.79-11.3,15.62,15.62,0,0,1,4.13-11.13q4.14-4.38,12.56-4.38t12.82,4q4.38,4,4.38,11.3t-4.21,11.72Q118,78.73,109.09,78.73Z" />
              </g>
            </g>
          </svg>
          <div *ngIf="isRuoOpen" class="isTooltipMobile">
            <p>
              Exclusive offers come in real-time (up to 24hrs later) from hosts that analyze your request and often
              reply
              with discounted prices, a personal note,
              and fulfilling your selected wishes.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="map-btn-mobile" (click)="openMapWindow()">
      <img src="../../../assets/img/icons/icon-map-pin.svg" alt="Map Icon" />
      <span>Show on map</span>
    </div>
  </div>

  <!-- Desktop Carousel -->
  <div *ngIf="!isMobile()" class="carousel__desktop">
    <ngb-carousel [interval]="8000" *ngIf="offerInfo && offerInfo.propertyPics" (slide)="onSlidePropertyPics($event)">
      <ng-template ngbSlide ngbSlide *ngFor="let image of offerInfo.propertyPics; let i = index" [id]="i">
        <div *ngIf="image.preloaded" [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                      'background-position': 'center center',
                      'background-repeat': 'no-repeat',
                      'background-size': 'cover',
                      'display': 'inline-block',
                      'height': '100%',
                      'width': '100%',
                      'background-color': 'rgba(0,0,0,.8)',
                      'position': 'relative',
                      'transition': 'transform 0.1s linear 0s',
                      'height': '550px'}"></div>
      </ng-template>
    </ngb-carousel>
  </div>

  <!-- Mobile Carousel -->
  <section *ngIf="isMobile() && offerInfo && offerInfo.propertyPics" class="carousel__mobile">
    <swiper #usefulSwiperMobile [config]="config" style="width: 100%;">
      <div class="swiper-wrapper">
        <img class="swiper-slide" *ngFor="let image of offerInfo.propertyPics, let i = index" [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat',
                        'background-size': 'cover',
                        'display': 'inline-block',
                        'width': '100%',
                        'background-color': 'rgba(0,0,0,.8)',
                        'position': 'relative',
                        'transition': 'transform 0.1s linear 0s',
                        'height': '350px'}" />
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </swiper>
  </section>

  <!-- Property Name & Location for Mobile -->
  <div *ngIf="isMobile()  && this.offerInfo" class="property__info flex-col w-100 gap-1">
    <div class="flex jc-sb ai-c gap-1">
      <h3 class="property__name">{{ offerInfo.hotel.name }}</h3>
      <div class="map-btn-mobile" (click)="openMapWindow()">
        <img src="../../../assets/img/icons/icon-map-pin.svg" alt="Map Icon" />
        <span>Show on map</span>
      </div>
    </div>

    <div *ngIf="!isOffer" class="property__request-offer flex ai-c">
      <a (click)="requestUniqueOffer()">
        <img src="../../../../assets/img/icons/icon_fire.svg" alt="Fiery Discount Icon for Unique Offers" />
        Request Exclusive Offer
      </a>
      <div #ruoOverview (click)="isRuoOpen = !isRuoOpen" class="tooltip-trigger-icon">
        <svg class="tooltip-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218 218">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <circle cx="109" cy="109" r="109" />
              <path class="tooltip-icon-i"
                d="M83.62,90.37h41.32V167.6h9.44v3H84.3v-3h9.27V93.4H83.62Zm25.47-11.64q-9,0-12.74-4.55a17,17,0,0,1-3.79-11.3,15.62,15.62,0,0,1,4.13-11.13q4.14-4.38,12.56-4.38t12.82,4q4.38,4,4.38,11.3t-4.21,11.72Q118,78.73,109.09,78.73Z" />
            </g>
          </g>
        </svg>
        <div *ngIf="isRuoOpen" class="isTooltipMobile">
          <p>
            Exclusive offers come in real-time (up to 24hrs later) from hosts that analyze your request and often
            reply
            with discounted prices, a personal note,
            and fulfilling your selected wishes.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- TODO: show gallery button needs functionality -->
  <!-- <button class="gallery__show flex ai-c jc-c gap-05">
      Show Gallery
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" fill="none">
        <path
          fill="#000"
          d="M.75 3.719V.813C.75.5 1 .25 1.313.25h2.906c.154 0 .281.127.281.281v.938a.282.282 0 0 1-.281.281H2.25v1.969A.282.282 0 0 1 1.969 4H1.03a.282.282 0 0 1-.281-.281ZM7.5.53v.938c0 .154.127.281.281.281H9.75v1.969c0 .154.127.281.281.281h.938a.282.282 0 0 0 .281-.281V.813a.561.561 0 0 0-.563-.563H7.781A.282.282 0 0 0 7.5.531ZM10.969 7h-.938a.282.282 0 0 0-.281.281V9.25H7.781a.282.282 0 0 0-.281.281v.938c0 .154.127.281.281.281h2.907c.311 0 .562-.25.562-.563V7.281A.282.282 0 0 0 10.969 7ZM4.5 10.469V9.53a.282.282 0 0 0-.281-.281H2.25V7.281A.282.282 0 0 0 1.969 7H1.03a.282.282 0 0 0-.281.281v2.907c0 .311.25.562.563.562h2.906a.282.282 0 0 0 .281-.281Z"
        />
      </svg>
    </button> -->

  <!-- Main Content & Sidebar -->
  <div class="property__content flex jc-c gap-3">
    <main class="property__main">

      <div *ngIf="isOffer" class="offer-note__property-page flex-col">
        <div *ngIf="offerNote" class="offer-note__property-text">
          <div class="flex ai-c gap-1 mb-2">
            <img *ngIf="offerNote" [src]="hotelierIcon != null ? hotelierIcon : appLogo" />
            <h4 class="">The host, {{ hotelierName }}, added a personal note!</h4>
          </div>
          <p><i>{{ offerNote }}</i></p>
        </div>
        <div class="offer-note__property-details flex-col jc-c gap-05">
          <div class="offer-note__property-discount" *ngIf="isOffer">
            <div class="flex-col jc-start gap-05">
              <div class="flex ai-c gap-05">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="none">
                  <path fill="#ffa9bd" fill-rule="evenodd"
                    d="M5.773 17.7c-.195 0-.392.015-.594.015-3.071 0-6.076-2.693-4.878-6.138C1.499 8.132 4.61 6.96 4.375 2.699c0 0 1.203.434 1.856 2.625-.353.49-.768.98-1.188 1.469-.939 1.085-1.906 2.204-2.464 3.805a5.352 5.352 0 0 0-.287 2.66 5.445 5.445 0 0 0 1.04 2.481 6.607 6.607 0 0 0 2.44 1.961ZM18.263 11.927c0 3.839-2.13 5.056-4.784 5.176 1.563-1.143 2.347-3.052 2.35-5.73a11.201 11.201 0 0 0-1.17-5.094 6.33 6.33 0 0 0-.14-2.24 10.715 10.715 0 0 1 2.746 3.564c.645 1.359.985 2.832.998 4.324Z"
                    clip-rule="evenodd" />
                  <path fill="#FF577F" fill-rule="evenodd"
                    d="M15.424 11.374c0 2.82-.876 4.72-2.662 5.731-1.024.595-2.365.884-4.013.884a6.603 6.603 0 0 1-2.852-.661 6.304 6.304 0 0 1-2.239-1.814 5.068 5.068 0 0 1-.969-2.317 4.982 4.982 0 0 1 .273-2.482c.53-1.53 1.48-2.627 2.393-3.684.348-.4.689-.799 1-1.21C7.4 4.445 8.107 2.895 7.516.401c.845.457 2.88 1.958 3.123 5.875l.03.49.325-.37c.049-.058 1.114-1.3.044-3.792.302.22.59.457.862.71a10.683 10.683 0 0 1 2.22 2.82c.155.278.296.563.422.855.594 1.391.894 2.882.883 4.385Z"
                    clip-rule="evenodd" />
                  <path fill="#FDF2F5"
                    d="M7.754 8.725c.361-.001.712.117.993.335.178.119.324.276.425.46.1.184.154.388.156.595-.002.21-.056.417-.159.603a1.637 1.637 0 0 1-.438.504c-.357.268-.8.41-1.254.402-.435.017-.86-.13-1.182-.41a1.25 1.25 0 0 1-.311-.431 1.204 1.204 0 0 1-.099-.516 1.315 1.315 0 0 1 .126-.6c.088-.188.22-.354.386-.487.181-.148.39-.26.617-.33.237-.082.488-.124.74-.125Zm-.302.649a.234.234 0 0 0-.187.085.316.316 0 0 0-.074.223c.004.293.066.583.181.854.036.103.09.198.162.282a.257.257 0 0 0 .197.078c.163 0 .256-.107.256-.32 0-.315-.067-.627-.197-.916-.093-.186-.203-.282-.328-.286h-.01Zm1.064 3.057 1.326-2.134c.353-.588.59-1.002.712-1.242a.813.813 0 0 1 .212-.286.504.504 0 0 1 .294-.071c.277 0 .415.063.415.196a1.69 1.69 0 0 1-.34.617c-.17.236-.41.604-.72 1.101l-1.348 2.184c-.278.49-.534.944-.768 1.362-.051.114-.122.22-.21.313a.36.36 0 0 1-.24.078.903.903 0 0 1-.387-.073c-.095-.042-.143-.093-.143-.157a.41.41 0 0 1 .092-.21c.083-.121.325-.481.724-1.08l.381-.598Zm2.798-.778c.362-.002.713.116.995.333.178.119.323.277.424.46a1.227 1.227 0 0 1-.004 1.197 1.548 1.548 0 0 1-.438.505c-.357.268-.8.41-1.254.401-.434.017-.859-.13-1.182-.409a1.253 1.253 0 0 1-.31-.431 1.206 1.206 0 0 1-.1-.516 1.322 1.322 0 0 1 .127-.6c.088-.188.22-.354.385-.487.183-.147.393-.26.62-.33a2.33 2.33 0 0 1 .737-.123Zm-.302.646a.244.244 0 0 0-.19.086.33.33 0 0 0-.071.223c.003.294.066.585.184.857a.883.883 0 0 0 .159.281.256.256 0 0 0 .197.076c.164 0 .256-.105.256-.32a2.228 2.228 0 0 0-.192-.914c-.095-.188-.205-.284-.343-.289Z" />
                </svg>
                <h5>Hot Vervendo Offer</h5>
              </div>
              <div class="offer-label">
                <span>{{ bestDiscount.discountUp ? '-' : '+' }}{{ bestDiscount.discount.toFixed(0) }}%</span>
                <span>{{ bestDiscount.oldPrice }}€ /night</span>
                <span>{{ bestDiscount.newPrice }}€ /night</span>
              </div>
            </div>
          </div>
          <div class="divider-vertical"></div>
          <div class="offer-note__property-expiry">
            <div class="flex-col jc-start gap-05">
              <div class="flex ai-c gap-05">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none">
                  <path fill="#ffa9bd"
                    d="M14.974 2.342a2.569 2.569 0 0 0-3.276-.28 7.147 7.147 0 0 1 3.645 3.4 2.547 2.547 0 0 0-.37-3.12ZM6.063 2.16a2.564 2.564 0 0 0-3.396.182A2.542 2.542 0 0 0 2.5 5.737 7.147 7.147 0 0 1 6.063 2.16Z" />
                  <path fill="#FF577F"
                    d="M8.988 2.413a6.222 6.222 0 0 0-4.396 10.613L3.46 14.159a.447.447 0 1 0 .64.627l1.182-1.182a6.177 6.177 0 0 0 7.502-.036l1.218 1.218a.445.445 0 0 0 .627-.627l-1.196-1.177a6.223 6.223 0 0 0-4.444-10.57Zm3.32 7.746a.445.445 0 0 1-.591.21L8.543 8.83V4.942a.444.444 0 1 1 .89 0v3.333l2.666 1.293a.444.444 0 0 1 .218.591h-.01Z" />
                </svg>
                <h5>Available for</h5>
              </div>
              <div class="offer-label">
                <span>{{ expiresInDays }}d</span>
                <span>{{ expiresInHours }}h</span>
                <span>{{ expiresInMinutes }}m</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="finalWishes && finalWishes.size > 0" class="wishes">
        <div class="flex ai-base jc-sb">
          <h5 class="wishes__heading">Wishes your host can fulfill</h5>
          <span *ngIf="finalWishes" class="wishes__count">{{ totalSatisfied }} / {{ finalWishes.size }}</span>
        </div>
        <div class="wishes-container flex jc-sb" *ngFor="let wish of finalWishes | keyvalue">
          <span class="wishes__text">
            {{ wish.key }}
          </span>
          <svg [ngStyle]="wish.value ? {'fill':'#2C6DA9'} : {'stroke':'#2C6DA9'}" xmlns="http://www.w3.org/2000/svg"
            width="18" height="19" fill="none">
            <path
              d="M9.258 13.16 9 13.002l-.258.156-3.623 2.187.956-4.12.068-.294-.228-.197L2.72 7.962l4.215-.364.3-.026.118-.277L9 3.415l1.647 3.88.118.277.3.026 4.214.363-3.201 2.774-.228.197.068.294.96 4.118-3.62-2.185Z" />
          </svg>
        </div>
      </div>

      <div *ngIf="finalWishes && finalWishes.size > 0" class="divider-horizontal--light-blue-2"></div>

      <app-hotel-single-description [hotelDscription]="hotelDscription" [locations]="locations">
      </app-hotel-single-description>
      <!-- <app-hotel-single-location id="location" [locations]="locations"></app-hotel-single-location> -->

      <app-hotel-single-facilities [totalFacilities]="totalFacilities" [top5Facilities]="top5Facilities"
        [isVilla]="isVilla" [facilitiesSingle]="isVilla ? topFacilitiesVilla : null" [facilities]="facilitiesTab">
      </app-hotel-single-facilities>

      <div *ngIf="!isMobile()" class="divider-horizontal--light-blue-2"></div>

      <app-hotel-single-inner *ngIf="tabHeaderInfo" [hotelName]="hotelName" [roomOffers]="roomOffers"
        [nights]="tabHeaderInfo.numberOfNightsSafari" [cards]="offerInfo.creditCards" [hotelInfo]="offerInfo"
        (optionsChanged)="selectMeal($event)">
      </app-hotel-single-inner>

    </main>
    <aside class="property__sidebar">
      <div class="flex-col gap-1">
        <ngb-carousel [interval]="8000" *ngIf="offerInfo && offerInfo.propertyPics"
          (slide)="onSlidePropertyPics($event)">
          <ng-template ngbSlide ngbSlide *ngFor="let image of offerInfo.propertyPics; let i = index" [id]="i">
            <div *ngIf="image.preloaded" [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                                'background-position': 'center center',
                                'background-repeat': 'no-repeat',
                                'background-size': 'cover',
                                'display': 'inline-block',
                                'height': '100%',
                                'width': '100%',
                                'background-color': 'rgba(0,0,0,.8)',
                                'position': 'relative',
                                'transition': 'transform 0.1s linear 0s',
                                'height': '350px'}"></div>
          </ng-template>
          <!--<div class="imgNew" *ngIf="offerInfo && offerInfo.propertyPics" style="height: 550px; width: 100%;">
                <div *ngIf="offerInfo.propertyPics[0].preloaded" class="imgBig"
                  [ngStyle]="{ 'background-image': 'url(' + offerInfo.propertyPics[0].pictureUrl + ')'}">
                </div>
              </div>-->
        </ngb-carousel>
        <div class="price-container flex flex-col gap-1">
          <div *ngIf="selections.length > 0 || totalExpSelected > 0" class="price">
            <div *ngIf="selections.length > 0">
              <h3 class="price__heading">Room(s)</h3>
              <p class="price__text flex jc-sb" *ngFor="let selection of selections">
                <span>(x{{ selection.count }}) {{ selection.name }}</span>
                <span class="price__value-item">{{ selection.cost }}€</span>
              </p>
            </div>
            <div *ngIf="totalExpSelected > 0">
              <h3 class="price__heading">Experiences</h3>
              <div *ngIf="roomExpTotalSelected">
                <p class="price__text flex jc-sb" *ngFor="let exp of roomExpTotalSelected | keyvalue">
                  <span>x({{ exp.value }}) {{ exp.key }}</span>
                </p>
              </div>
            </div>
          </div>
          <div [ngStyle]="currentTotalCost > 0 ? {'color' : '#ff577f'} : {'color': '#2c6da9'}"
            class="nav__price flex jc-sb ai-c gap-1">
            <div class="flex-col ai-start">
              <h5 class="title">total booking</h5>
              <span *ngIf="currentTotalCost > 0" class="caption">(Tax Included)</span>
            </div>
            <h3 class="price__value-total">{{currentTotalCost}}€</h3>
          </div>
          <a [ngStyle]="currentTotalCost > 0 ? {'background-color' : '#ff577f'} : {'background-color': '#2c6da9'}"
            class="nav__button ai-c jc-c" (click)="currentTotalCost > 0 ? bookNow() : scrollToRooms();">{{
            currentTotalCost > 0 ?
            'Proceed to Checkout' : 'Choose Room Type' }}</a>
        </div>
      </div>
    </aside>
  </div>

  <!-- Property License ID -->
  <h5 *ngIf="offerInfo && (offerInfo.hotel.contractInfoAfm || offerInfo.hotel.contractInfoMhTe)" class="license">
    License No: {{ offerInfo.hotel.contractInfoMhTe.length > 0 ? offerInfo.hotel.contractInfoMhTe :
    offerInfo.hotel.contractInfoAfm }}
  </h5>

  <!-- Mobile Bottom Navbar -->
  <div class="nav__bottom" *ngIf="isMobile()">
    <div class="nav__price flex-col" [ngStyle]="currentTotalCost > 0 ? {'color' : '#ff577f'} : {'color': '#2c6da9'}">
      <h5 class="title">total booking</h5>
      <!-- <span *ngIf="currentTotalCost > 0" class="caption">(Tax Included)</span> -->
      <h3 class="value">{{currentTotalCost}}€</h3>
    </div>
    <a [ngStyle]="currentTotalCost > 0 ? {'background-color' : '#ff577f'} : {'background-color': '#2c6da9'}"
      class="nav__button ai-c jc-c" (click)="currentTotalCost > 0 ? bookNow() : scrollToRooms();">{{ currentTotalCost >
      0 ?
      'Proceed to Checkout' : 'Choose Room Type' }}</a>
  </div>

</div>

<!-- Mobile Map Overlay -->
<section *ngIf="isMobile()" id="right" class="right-sidebar-results overlay">
  <div class="menu-header" *ngIf="mobileFullsreenWindow.isMapOpen">
    <a href="javascript:void(0)" class="close-btn" (click)="closeFilterWindow('map')">&times; </a>
  </div>
  <div class="sidebar-item overlay-content">
    <div class="make-me-sticky">
      <div id="map-canvas">
        <app-map-canvas *ngIf="markers" [markers]="markers" [mapCenter]="mapCenter" [hotels]="hotels"
          [hasInfoWindow]="false"></app-map-canvas>
      </div>
    </div>
  </div>
</section>
<!-- PROPERTY PAGE END -->

<!-- Swiper JS -->
<script src="../../../../../node_modules/swiper/js/swiper.js"></script>

<!-- Initialize Swiper -->
<script>
  var swiper = new Swiper(".swiper-container", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
</script>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white;">Loading...</p>
</ngx-spinner>